import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { globalValues } from '@app/globals';
import { CustomHttp } from '@service/customhttp.service';
import { RequestLibraryService } from '@service/core/request-library.service';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class SenderPhoneNumberService {
    private customHttp: CustomHttp;
    constructor(
        private http: HttpClient,
        private router: Router,
        private requestLibrary: RequestLibraryService
    ) {
        this.customHttp = new CustomHttp(http, router);
    }

    getSenderPhoneNumberData() {
        return this.requestLibrary.Get('/smstemplates/senderphonenumber');
    }

    postSenderPhoneNumberData(model) {
        return this.requestLibrary.Post('/smstemplates/senderphonenumber', model);
    }
}
